import axiosClient from './axiosClient';

const chatApi = {
  createGroup: (data, params = {}) => {
    const url = '/chat/groups';
    return axiosClient.post(url, data, { params });
  },
  getGroups: (params) => {
    const url = '/chat/groups';
    return axiosClient.get(url, { params });
  },
  updateGroup: (id, data) => {
    const url = `/chat/group/${id}`;
    return axiosClient.put(url, data);
  },
  getMessages: (id, params) => {
    const url = `/chat/messages/${id}`;
    return axiosClient.get(url, { params });
  },
  createCommentApi: (data) => {
    const url = `/discussions-comment`;
    return axiosClient.post(url, data);
  },
  replyCommentApi: (data) => {
    const url = `/discussions-comment`;
    return axiosClient.post(url, data);
  },
  getReplyApi: (data) => {
    const url = `/discussions-comment?discussion=${data.discussion}&parent=${data.parent}`;
    return axiosClient.get(url, data);
  },
  createMessage: (id, data, config = {}) => {
    const url = `/chat/messages/${id}`;
    return axiosClient.post(url, data, config);
  },
  sortingMessage: (data) => {
    const url = `/groups/get-discussions-by-intake/${data}?sort=-1`;
    return axiosClient.get(url);
  },
  getGroupById: (id) => {
    const url = `/chat/groups/${id}`;
    return axiosClient.get(url);
  },
  deleteMessages: (id) => {
    const url = `/chat/message/${id}`;
    return axiosClient.delete(url);
  },
};

export default chatApi;
